import { makeStyles } from "@material-ui/core/styles";
import { relative } from "path";

const drawerWidth = 240;

const styles = makeStyles(theme => ({
  root: {
    flexGrow: 1
  },
  iconUrl: {
    fontWeight: 300,
    fill: "#0073cf",
    // fontSize: "15px",
    marginRight: "-10px",
    fontSize: 24,
    [theme.breakpoints.down("xs")]: {
      marginRight: 0
    }
  },
  iconUrlOpen: {
    fontWeight: 300,
    fill: "white",
    // fontSize: "15px"
    marginRight: "-10px",
    fontSize: 24,
    [theme.breakpoints.down("xs")]: {
      marginRight: 0
    }
  },
  headerClass: {
    zIndex: 1301,
    boxShadow: "none",
    transition: "top 0.6s"
  },
  menuButton: {
    marginRight: theme.spacing(2)
  },
  toolbarStyle: {
    minHeight: 37,
    height: 37,
    [theme.breakpoints.down("xs")]: {
      padding: 0
    }
  },
  toolbarSecondStyle: {
    minHeight: 40,
    height: 56,
    background: "white",
    position: "relative",
    width: "100%"
  },
  navbarDisplayFlex: {
    display: `flex`,
    justifyContent: `space-between`,
    height: "100%",
    [theme.breakpoints.down("xs")]: {
      paddingLeft: 0,
      paddingRight: 0
    }
  },
  navDisplayFlex: {
    display: `flex`,
    justifyContent: `space-between`,
    alignItems: "center",
    [theme.breakpoints.down("xs")]: {
      padding: 0
    }
  },
  linkMainHeaderText: {
    padding: "5px 30px",
    [theme.breakpoints.down("xs")]: {
      padding: "5px 15px"
    }
  },
  linkText: {
    textDecoration: `none !important`,
    fontWeight: "normal",
    "&:hover": {
      background: "white",
      color: theme.palette.primary.dark,
      fontWeight: "bold"
    },
    "& .MuiTypography-body1": {
      fontSize: "15px"
    },
    "&:hover .MuiTypography-body1": {
      fontWeight: "bold"
    }
  },
  linkTextAccesoClientes: {
    display: "flex",
    alignItems: "center",
    width: "175px",
    textDecoration: `none !important`,
    fontWeight: "normal",
    padding: "0px 19px",
    "&:hover": {
      background: "transparent",
      color: "#0073cf",
      fontWeight: "normal",
      backgroundColor: "#E6E6E6"
    },
    "&:hover .MuiSvgIcon-root": {
      fill: "#0073cf"
    },
    "& .MuiTypography-body1": {
      fontSize: "15px"
    },

    [theme.breakpoints.down("sm")]: {
      width: "auto",
      paddingLeft: 10,
      paddingRight: 10,
      height: 37
    }
  },

  linkTextAccesoClientesOpen: {
    display: "flex",
    alignItems: "center",
    width: "175px",
    textDecoration: `none !important`,
    fontWeight: "normal",
    backgroundColor: "#E6E6E6",
    color: "#0073cf",
    padding: "0px 19px",
    [theme.breakpoints.down("sm")]: {
      paddingLeft: 10,
      paddingRight: 10,
      width: "auto",
      height: 37
    }
  },
  activeLinkText: {
    textDecoration: `none !important`,
    background: "white",
    color: theme.palette.primary.dark,
    fontWeight: "bold",
    "& .MuiTypography-body1": {
      fontWeight: "bold",
      fontSize: "15px"
    }
  },
  linkTextSecond: {
    textDecoration: `none  !important`,
    color: theme.palette.primary.dark
  },
  logoMainContainer: {
    display: "flex",
    alignItems: "center",
    width: "25%",
    marginLeft: "-10px"
  },
  logoContainer: {
    width: "fit-content",
    display: "flex",
    "& img": {
      width: "125px"
    }
  },
  buttonStyle: {
    textTransform: `none`,
    background: theme.palette.primary.dark,
    color: "white",
    fontWeight: "bold",
    height: "100%",
    "&:hover": {
      backgroundColor: "#0A27D3"
    }
  },
  relativeStyles: {
    position: "relative"
  },
  absoluteSContainer: {
    top: "56px",
    position: "absolute",
    background: "lightgrey",
    width: "100%",
    minHeight: "200px",
    color: "red",
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
    left: "0",
    right: 0,
    marginLeft: "auto",
    marginRight: "auto",
    maxWidth: "960px",
    boxShadow:
      "0 2px 4px -1px rgb(0 0 0 / 20%), 0 1px 10px 0 rgb(0 0 0 / 12%), 0 4px 5px 0 rgb(0 0 0 / 14%)",
    borderBottomLeftRadius: "8px",
    borderBottomRightRadius: "8px"
  },
  hamburguerMenu: {
    color: "#000000",
    width: 35,
    height: 35
  },
  itemMainMenu: {
    flexDirection: "column",
    position: "relative",
    paddingTop: 2,
    paddingBottom: 3,
    "&:hover": {
      opacity: 1,
      backgroundColor: "transparent",
      "& $iconArrowMainMenu": {
        fill: theme.palette.primary.dark
      }
    },
    "&::before": {
      content: '""',
      position: "absolute",
      zIndex: "2",
      left: "0",
      right: "0"
    },
    "&:before": {
      content: '""',
      position: "absolute",
      zIndex: "0",
      left: 16,
      right: "100%",
      bottom: "0",
      background: theme.palette.primary.dark,
      height: "3px",
      WebkitTransitionProperty: "right",
      transitionProperty: "right",
      WebkitTransitionDuration: "0.3s",
      transitionDuration: "0.3s",
      WebkitTransitionTimingFunction: "ease-out",
      transitionTimingFunction: "ease-out"
    },
    "&:hover:before": {
      right: 16
    },
    "& .MuiTypography-body1": {
      fontSize: "15px"
    }
  },
  uniqueLink: {
    padding: "7px 7px",
    display: "flex",
    marginTop: "0px",
    fontSize: "15px",
    color: theme.palette.primary.dark,
    textDecoration: "none !important"
  },
  lineActivePlan: {
    background: theme.palette.primary.dark,
    height: "3px",
    width: "100%",
    position: "relative",
    bottom: "-3px"
  },
  containerIconArrowMain: {
    display: "contents"
  },
  iconArrowMainMenu: {
    transform: "rotate(0deg)",
    transition: "transform 0.5s linear",
    fill: "#e7e7e7",
    width: "30px",
    height: "27px",
    fontWeight: "bold"
  },
  activeArrowPlan: {
    transform: "rotate(180deg)",
    transition: "transform 0.5s linear",
    color: theme.palette.primary.dark
    // fontSize: "25px"
  },
  accessClients: { position: "relative" },
  accessClientsLinksContainer: {
    zIndex: 99,
    position: "absolute",
    top: 41,
    right: 0,
    backgroundColor: "#E6E6E6",
    borderBottomLeftRadius: "8px",
    borderBottomRightRadius: "8px",
    fontFamily: "Trebuchet",
    boxShadow:
      "0 2px 4px -1px rgb(0 0 0 / 20%), 0 1px 10px 0 rgb(0 0 0 / 12%), 0 4px 5px 0 rgb(0 0 0 / 14%)",
    width: "240px",
    [theme.breakpoints.down("xs")]: {
      top: 37
    }
  },
  textoMenuAccesoCliente: {
    fontSize: "15px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "1.07",
    letterSpacing: "normal",
    color: "#727272",
    textDecoration: "none",
    display: "flex",
    padding: "15px 10px 15px 15px",
    justifyContent: "space-between",
    alignItems: "center",
    "&:hover": {
      color: "#00338d",
      backgroundColor: "#f3f3f3",
      fontWeight: "bold"
    },
    "&:hover $idFlechaMenuAcceso": {
      color: "#0098db",
      opacity: 1
    }
  },
  idFlechaMenuAcceso: {
    fontSize: "15px",
    fontWeight: 700,
    opacity: 0
  }
}));

export default styles;
